import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const FocusBrandAchievement = () => {
  const data = [
    ['Brand', 'Achievement (%)'],
    ['Brand A', 105],
    ['Brand B', 110],
    ['Brand C', 95],
    ['Brand D', 101],
    ['Brand E', 108],
  ];

  const options = {
    title: 'Focus Brand Achievement',
    hAxis: { title: 'Brand' },
    vAxis: { title: 'Achievement (%)' },
    legend: { position: 'none' },
    bar: { groupWidth: '75%' },
    colors: ['#2196F3'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default FocusBrandAchievement;